/** Starts a download from a short-lived signed URL. The browser path is a
 * temporary anchor (no window.open: popup blockers, and it must not render
 * inline). The native shells cannot follow an anchor download, so there the
 * bytes go through the existing saveFile bridge. */
import { NativeBridge } from '../../../services/NativeBridge';
import { saveFileNative } from '../../../utils/nativeFileSave';

function clickAnchor(url: string, name: string) {
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  link.rel = 'noopener';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export async function downloadFromSignedUrl(url: string, name: string, mimeType: string): Promise<void> {
  if (NativeBridge.isRunningNatively()) {
    const res = await fetch(url);
    if (!res.ok) throw new Error('The file could not be downloaded.');
    const blob = await res.blob();
    await saveFileNative(blob.type ? blob : new Blob([blob], { type: mimeType }), name, name.split('.').pop() ?? '');
    return;
  }
  clickAnchor(url, name);
}
